module.exports = __webpack_public_path__ + "assets/img/Leedon Green.acea734c.png";